'use client';

import { useParams } from '@/lib/router';
import { MetaFormView } from '@/components/MetaFormView';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';

export default function EditMetaPage() {
  const { id } = useParams<{ id: string }>();
  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <MetaFormView goalId={id!} />
    </>
  );
}
